import { isValidCinemaLang, CINEMA_WILDCARD_HANDLER } from "./constants";

/**
 * Path-preserving cinema redirect: drops an optional valid lang prefix and the "default"
 * wildcard in the cinema slot from the path segments, returns the rest as "/rest"
 * ("" -> cinema HP). Unifies "/akce/x", "/cz/akce/x" and "/cz/default/akce/x".
 *
 * Shared by the h3 handler (server/middleware/02.cinemaRedirect.ts) and the route
 * middleware (middleware/02.redirectToValidCinema.global.ts) so the same URL resolves to
 * the same target on full page loads, SPA navigation and the CINEMA_EDGE_REDIRECT=0
 * fallback.
 */
export const buildCinemaRedirectRest = (segments: string[]): string => {
  const parts = [...segments];
  if (isValidCinemaLang(parts[0])) parts.shift();
  if (parts[0] === CINEMA_WILDCARD_HANDLER) parts.shift();
  return parts.length ? "/" + parts.join("/") : "";
};
